import * as React from 'react'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Typography from '@mui/material/Typography'
import { Card, CardContent, Divider, FormControlLabel, TextField, Checkbox } from '@mui/material'
import Language from '../../components/Language/Language'
import image from '../../images/graph.png'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useRegisterMutation } from '../../store/api/authApi'
import { CommonTextBox, ConfirmPassword, Password, TaxId } from '../../components/TextBox'
import { Gender } from '../../components/SelectBox'
import { useTranslation } from 'react-i18next'
import InputMask from 'react-input-mask'
import { showErrorToast, showSuccessToast, showWarningToast } from '../../constToast/constToast'
import TermsConditions from './TermsConditions'

export default function RegisterSupplier() {
  const { t } = useTranslation('register')
  const { t: l } = useTranslation('loginAndRegister')
  const navigate = useNavigate()
  const handleLogin = () => {
    navigate('/login')
  }

  const [fullName, setFullName] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [vendorId, setVendorId] = useState(0)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [gender, setGender] = useState('')
  const [taxId, setTaxId] = useState('')
  const [phoneNumber, setPhoneNumber] = useState(null)
  const [position, setPosition] = useState('')
  const [chechbox, setChecbox] = useState(false)
  const [open, setOpen] = useState(false)

  const [addRegister] = useRegisterMutation()

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // 
    }
  }
  const isPhoneValid = phoneNumber && !phoneNumber.includes('_');

  const handleRegister = async (e) => {
    e.preventDefault()

    if (phoneNumber.includes('_')) {
      return; // submit etmə
    }

    const data = await addRegister({
      userId: 0,
      fullName,
      statusId: 0,
      userName: email,
      email,
      password,
      confirmPassword,
      changePassword: true,
      gender,
      taxId,
      vendorId: vendorId,
      userTypeId: 0, //supplier
      language: 1,
      phoneNumber,
      position,
    })

    if (data?.error) {
      showErrorToast(`${data?.error?.data?.errors?.user ||
        data?.error?.data?.errors?.password ||
        data?.error?.data?.errors?.confirmPassword ||
        data?.error?.data?.errors?.email || (data?.error?.data?.errors && 'Please Fill data')
        }`)
    } else {
      showSuccessToast('Register Successfully')
      showWarningToast('Please Check Your Email')
      navigate('/login')
    }
  }
  const contentRegister = (
    <>
      <Box
        sx={{
          display: 'flex',
          aligntItems: 'center',
          justifyContent: 'space-between',
          mt: 2,
          mb: 1,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar sx={{ m: 1, backgroundColor: '#2196f3' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {l('supplier')}
          </Typography>
        </Box>
        <Box>
          <Language />
        </Box>
      </Box>

      <Grid container display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Grid item xs={7}>
          <CommonTextBox label={t('fullName')} value={fullName} setValue={setFullName} required={true} />
        </Grid>
        <Grid item xs={4}>
          <TaxId setCompanyName={setCompanyName} setTax={setTaxId} tax={taxId || ''} setVendorId={setVendorId} required={true} />
        </Grid>
        <Grid item xs={12} mt={2} mb={2}>
          <CommonTextBox label={t('companyName')} value={companyName} setValue={setCompanyName} disabled={true} />
        </Grid>
        <Grid item xs={7} mb={2}>
          <CommonTextBox required label={l('emailAddress')} value={email} setValue={setEmail} />
        </Grid>
        <Grid item xs={4} mb={2}>
          <Gender gender={gender} setGender={setGender} required={true} />
        </Grid>
        <Grid item xs={7} mb={2}>
          <CommonTextBox required label={t('position')} value={position} setValue={setPosition} />
        </Grid>
        <Grid item xs={4} mb={2}>
          <TextField
            size="small"
            fullWidth
            label={t('contactPhone')}
            value={phoneNumber}
            name="phoneNumber"
            onChange={(e) => setPhoneNumber(e.target.value)}
            required
            error={!!phoneNumber && !isPhoneValid}
            helperText={
              !!phoneNumber && !isPhoneValid
                ? t('Phone Required') // "Telefon nömrəsini tam daxil edin"
                : ''
            }
            InputProps={{
              inputComponent: InputMask,
              inputProps: {
                mask: '(+999) 99-999-9999',
                maskChar: '_',
              },
            }}
          />

        </Grid>
        <Grid item xs={5}>
          <Password password={password} setPassword={setPassword} />
        </Grid>
        <Grid item xs={5}>
          <ConfirmPassword confirmPassword={confirmPassword} setConfirmPassword={setConfirmPassword} />
        </Grid>
        <Grid item xs={5}>
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            onChange={(e) => setChecbox(e.target.checked)}
            label={<p>Accept <span style={{ color: 'blue' }} onClick={() => setOpen(true)}>TERMS & CONDITIONS</span></p>}
          />
        </Grid>
      </Grid>

      <Divider />

      <Grid container display="flex" alignContent="space-around" justifyContent="center">
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }} mt={4}>
          <Button
            onClick={handleRegister}
            onKeyDown={handleKeyDown}
            type="submit"
            variant="contained"
            sx={{ width: 250 }}
            disabled={!chechbox}
          >
            {t('register')}
          </Button>
        </Grid>



      </Grid>
    </>
  )

  const contentText = (
    <>
      <img
        alt="Under development"
        src={image}
        style={{
          position: 'absolute',
          zIndex: -1,
          top: -250,
          left: -110,
          opacity: '10%',
        }}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 150,
        }}
      >
        <Typography variant="h4" sx={{ color: 'white' }}>
          Sola Soft
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 150,
        }}
      >
        <Typography variant="subtitle1" sx={{ color: 'white', textAlign: 'center' }}>
          {l('slogan')}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end',
          height: 120,
        }}
      >
        <Typography variant="subtitle1" sx={{ color: 'white', textAlign: 'center' }}>
          {t('question')} {l('loginName')}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end',
          height: 60,
        }}
      >
        <Button variant="outlined" sx={{ color: 'white' }} onClick={handleLogin}>
          {l('loginName')}
        </Button>
      </Box>
    </>
  )

  return (
    <div className="animation-bg">
      <TermsConditions setOpen={setOpen} open={open} />

      <Grid container width={{ xs: 400, sm: 400, md: 800 }}>
        <Grid item sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} md={4} lg={4} xl={4}>
          <Card
            sx={{
              zIndex: 2,
              position: 'relative',
              backgroundColor: '#2196f3',
              height: 530,
            }}
          >
            <CardContent>{contentText}</CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
          <Card sx={{ zIndex: 2, position: 'relative', height: 530 }}>
            <CardContent>{contentRegister}</CardContent>
          </Card>
        </Grid>
      </Grid>
      <div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
      </div>
    </div>
  )
}
